import {FacebookConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/facebookconfiguration';
import {FacebookLinkedAccount} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/facebook/facebooklinkedaccount';
import {EnterpriseConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';
import {Task} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/task';
import {TaskIds} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/taskids';

import BookSvg from '/src/com/yext/listingslaunchstorm/public/icons/book.svg';
import FacebookLogoLargeSvg from '/src/com/yext/listingslaunchstorm/public/icons/facebook-logo-large.svg';
import FacebookLogoSvg from '/src/com/yext/listingslaunchstorm/public/icons/facebook-logo.svg';

export const FacebookLinkedAccountTask = new Task({
  id: TaskIds.FACEBOOK_LINKED_ACCOUNT,

  getCard: (_enterpriseConfiguration, _index, selectedPageId, setSelectedPageId, disabled) => ({
    id: TaskIds.FACEBOOK_LINKED_ACCOUNT,
    title: yext.msg('Linked Accounts'),
    icon: <FacebookLogoSvg />,
    isSelected: TaskIds.FACEBOOK_LINKED_ACCOUNT === selectedPageId,
    onClick: disabled ? undefined : () => setSelectedPageId(TaskIds.FACEBOOK_LINKED_ACCOUNT),
    content: undefined,
  }),

  getPage: (enterpriseConfiguration, setEnterpriseConfiguration, pageControls) => ({
    id: TaskIds.FACEBOOK_LINKED_ACCOUNT,
    layoutHeader: {
      icon: <FacebookLogoLargeSvg />,
      title: yext.msg('Facebook'),
      description: yext.msg('Link your Facebook account. Linking your account allows you to manage your Facebook listings through this platform. Your account will stay linked and can be found in Account Settings.'),
      resourceLink: {
        src: 'https://hitchhikers.yext.com/tracks/listings/lis320-facebook/',
        displayText: yext.msg('Learn About the Facebook Integration'),
        icon: <BookSvg />,
      },
    },
    content: <FacebookLinkedAccount
      facebookConfiguration={
        enterpriseConfiguration.facebookConfiguration ?? FacebookConfiguration.empty()
      }
      setFacebookConfiguration={facebookConfiguration => setEnterpriseConfiguration(
        new EnterpriseConfiguration({...enterpriseConfiguration, facebookConfiguration}),
      )}
    />,
  }),

  isComplete: enterpriseConfiguration => (
    isConfigurationComplete(enterpriseConfiguration.facebookConfiguration)
  ),

  isSectionSkipped: enterpriseConfiguration => enterpriseConfiguration?.facebookConfiguration?.skipSetup === true
});

/**
 * @param {FacebookConfiguration | undefined} facebookConfiguration
 * @returns {boolean}
 */
function isConfigurationComplete(facebookConfiguration) {
  const brandIdComplete = (facebookConfiguration?.brandId || facebookConfiguration?.skipBrandId);
  return !!(facebookConfiguration?.linkedAccount && brandIdComplete)
    || !!facebookConfiguration?.skipSetup;
}
